(ns frontend.ui.component.lp-portal.big-figure.view
  (:require
   [frontend.ui.component.lp-portal.big-figure.style :as style]
   [herb.core :refer [<class]]))

(defn big-figure
  [value label]
  [:div {:class (<class style/figure-container)}
   [:span {:class (<class style/figure)} value]
   [:span {:class (<class style/figure-label)} label]])
